<div class="alert-component" *ngFor="let alert of alertService.getAlerts(); let i = index">
  <div class="alert alert--{{ alert['type'] }}" *ngIf="alert['message']">
    <img src="assets/img/alert-img-{{ alert['type'] }}.png" alt="logo-img" width="24" height="24" />
    <span class="alert__msg">{{ alert['message'].toUpperCase() | translate }}</span>
    <img class="alert__close" src="assets/img/close.png" alt="logo-img" width="14" height="14" (click)="alertService.removeAlert(i, true)" />
  </div>
</div>
